// extracted by mini-css-extract-plugin
module.exports = {"header":"style-module__header___1nlnp","illustration":"style-module__illustration___17n11","iconBackground":"style-module__iconBackground___3PVsj"};